import {
    ALL_FIELDS,
    type FieldKey,
    type FlagMap,
    SECTIONS,
    type ValueMap,
} from './feedingConfigFields';

export interface ConfigValidation {
    parsed: Record<FieldKey, number>;
    /** Fields whose value is not a number in range. */
    errors: FlagMap;
    /** The upper field of a band whose lower bound is above it. */
    orderErrors: FlagMap;
    isValid: boolean;
}

/** Parses the visible fields and checks each value and each band's order. */
export function validateConfigValues(
    values: ValueMap,
    fieldVisible: (key: FieldKey) => boolean
): ConfigValidation {
    const parsed = {} as Record<FieldKey, number>;
    const errors: FlagMap = {};
    for (const field of ALL_FIELDS) {
        // A field hidden in this scope must not be able to block the save.
        if (!fieldVisible(field.key)) continue;
        const n = Number.parseFloat(values[field.key]);
        parsed[field.key] = n;
        errors[field.key] = !(Number.isFinite(n) && (field.positive ? n > 0 : n >= 0));
    }
    const orderErrors: FlagMap = {};
    for (const section of SECTIONS) {
        if (!section.order) continue;
        const [lo, hi] = section.order;
        if (!fieldVisible(lo) || !fieldVisible(hi)) continue;
        if (!errors[lo] && !errors[hi] && parsed[lo] > parsed[hi]) orderErrors[hi] = true;
    }
    const isValid =
        ALL_FIELDS.every((field) => !fieldVisible(field.key) || !errors[field.key]) &&
        !Object.values(orderErrors).some(Boolean);
    return { parsed, errors, orderErrors, isValid };
}
